import Box from "@/common/components/Box"
import Button from "@/common/components/Button"
import TextField from "@/common/components/TextField"
import { ChevronsRight } from "lucide-react"
import { Link, useParams } from "react-router-dom"
import { ErrorResponse } from "@/common/types/errorResponse"
import { strategy } from "@/features/generalDocuments/constants/kind.constant"
import { useGeneralDocument } from "@/features/generalDocuments/hooks/useGeneralDocument"
import { dateIsoTransformer, dateTransformer } from "@/common/utils/dateTransformer"
import { ModalErrorMessage } from "@/common/components/ModalErrorMessage"
import { useState } from "react"

import { ModalDeleteDocument } from "@/features/generalDocuments/components/ModalDeleteDocument"
import GoBackButton from "@/common/components/GoBackButton";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper"

const Show = () => {
  const [errorData, setErrorData] = useState<ErrorResponse | boolean>(false)
  const { id } = useParams();

  const {
    data: document,
    isPending,
    refetch: refetchRequest,
    error: requestError = {} as any,
  } = useGeneralDocument({
    id,
  });

  return (
    <form>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2 items-center">
          <GoBackButton fallback="/general-documents" searchLastRouteFromFallback />
          <p className="text-white-400 font-normal">Documentos</p>
          <ChevronsRight color='#ffffffb3' />
          <h2>Documento</h2>
        </div>

        {document && (
          <div className="flex gap-4">
            <ModalDeleteDocument operationKlassToCheckPermission="Admin::GeneralDocuments::Destroy" documentId={id} onError={setErrorData} />
            <Link
              to={`/general-documents/${id}/edit`}
              className={"cursor-default"}
            >
              <Button operationKlassToCheckPermission="Admin::GeneralDocuments::Update" type="button"
                className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]" >
                Editar
              </Button>
            </Link>
          </div>
        )}
      </div>

      {isPending ? (
        <Box>
          Carregando...
        </Box>
      ) : (
        <ErrorMessageWrapper
          className="max-h-[calc(100vh-128px)]"
          statusCode={requestError?.status}
          refetchFunction={refetchRequest}
        >
          <Box className="flex flex-col gap-4 shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
            <p className="text-lg font-bold">Documento</p>
            <div className="flex gap-2">
              <TextField
                label="Nome do documento"
                className="w-2/4"
                disabled
                value={document?.data.display_name}
              />
              <TextField
                label="Tipo de documento"
                className="w-2/4"
                disabled
                value={document?.data ? strategy[document?.data.kind as keyof typeof strategy] : undefined}
              />
            </div>
            <div className="flex gap-2">
              <TextField
                label="Ultima Atualização"
                className="w-2/4"
                disabled
                value={document?.data.updated_at ? dateIsoTransformer(document?.data.updated_at) : ''}
              />
              <TextField
                label="Validade"
                className="w-2/4"
                disabled
                value={document?.data.expiration_date ? dateTransformer(document?.data.expiration_date) : 'Não informado'}
              />

            </div>
          </Box >
        </ErrorMessageWrapper >
      )}

      <ModalErrorMessage
        data={errorData as ErrorResponse}
        setData={setErrorData as React.Dispatch<React.SetStateAction<boolean>>}
        title="Deleção não concluída"
        message="Algo deu errado e a deleção não foi concluída."
      />
    </form >
  )
}

export default Show
